<cdk-accordion>
  <cdk-accordion-item #item="cdkAccordionItem" [expanded]="true">
    <div
      class="group h-8 pl-4 pr-2 flex items-center rounded-full hover:bg-gray-200 hover:cursor-pointer transition-colors"
    >
      <div
        class="flex flex-auto items-center gap-1 min-w-0"
        (click)="item.toggle()"
        role="presentation"
      >
        <span class="flex-auto truncate text-sm font-medium">Editors</span>
        <mat-icon
          class="flex-none"
          [class]="item.expanded ? 'rotate-0' : 'rotate-180'"
          >keyboard_arrow_up</mat-icon
        >
      </div>
    </div>

    @if (item.expanded) {
      <div class="text-sm overflow-hidden space-y-2 py-2">
        @for (editor of items(); track $index) {
          <div class="bg-white rounded-lg p-4 select-none" role="presentation">
            <div class="text-sm font-medium truncate">{{ editor.name }}</div>
            <div class="space-y-1">
              @for (range of editor.ranges; track $index) {
                <div class="text-xs text-gray-500 flex items-center gap-1">
                  <span>{{ range.fromDate | date: 'd MMM yyyy' }}</span> &ndash;
                  <span>{{ range.toDate | date: 'd MMM yyyy' }}</span>
                </div>
              }
              @empty {
                <div class="text-xs text-gray-500 flex items-center gap-1">Geen datumbereik beschikbaar</div>
              }
            </div>
          </div>
        } @empty {
          <div class="px-4 text-xs text-gray-500">Er zijn geen editors.</div>
        }
      </div>
    }
  </cdk-accordion-item>
</cdk-accordion>
